export default __webpack_public_path__ + "static/media/infoprofile.52d15bb1.svg";